/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import '@fancyapps/fancybox';

const papionGeoLocation = () => {
  const apiKey = 'AIzaSyBepJxGKfkmQOPDOmBB60HPhuulZHdzJEE';
  const cookieName = 'papion-geo-position';
  const cookieCountryName = 'papion-geo-country';

  const checkCookie = (name) => {
    var username = getCookie(name);
    return username != "";
  }

  const getCookie = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const setCookie = (cname, cvalue, exdays) => {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  const setPosition = (position) => {
    if (position && position.coords){
      setCookie(cookieName, JSON.stringify({lat: position.coords.latitude, lng: position.coords.longitude, from: 'browser'}), 30)
      getCountry();
    } else {
      getPositionFromGoogle();
    }
  }

  const getPositionFromGoogle = () => {
    var headers = new Headers();
    headers.append("Content-Type", "application/json");

    var raw = JSON.stringify({"considerIp":"true"});

    var requestOptions = {
      method: 'POST',
      headers: headers,
      body: raw,
      redirect: 'follow',
    };

    fetch(`https://www.googleapis.com/geolocation/v1/geolocate?key=${apiKey}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        if(result && result.location) {
          setCookie(cookieName, JSON.stringify({lat: result.location.lat, lng: result.location.lng, from: 'google'}), 30)
          getCountry();
        }
      })
      .catch(error => console.log('error', error));
  }

  const getCountry = () => {
    const cookie = getCookie(cookieName);

    if(cookie && cookie !== '') {
      const requestOptions = {
        method: 'GET',
        redirect: 'follow',
      };
      const cookieData = JSON.parse(cookie);

      fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${cookieData.lat},${cookieData.lng}&key=${apiKey}`, requestOptions)
        .then(response => response.json())
        .then(result => {
          if(result && result.status === 'OK') {
            const country = result.results.find(r => r.types && r.types.includes('country') && r.types.includes('political'))
            if(country) {
              setCookie(cookieCountryName, JSON.stringify(country.address_components[0]), 30)
              location.reload();
            }
          }
        })
        .catch(error => console.log('error', error));
    }
  }

  if(!checkCookie(cookieName) || !checkCookie(cookieCountryName)){
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(setPosition, getPositionFromGoogle);
    } else {
      getPositionFromGoogle()
    }
  }
}

$(document).ready(() => {
  const $body = $('body');
  const $menuTrigger = $('#menu-trigger');
  const $blockActivities = $('.block-activities');
  const $listFilters = $('.list__filters li');
  const $animatedInView = $('.animated-in-view');
  const $blocksAccordion = $('.block-accordion');
  const $gallery = $('.gallery');
  const $slideshow = $('.slideshow');

  papionGeoLocation();

  if (window.getComputedStyle(document.body).mixBlendMode) {
    $body.addClass('supports-mix-blend-mode');
  }
  if (window.getComputedStyle(document.body).backgroundBlendMode) {
    $body.addClass('supports-background-blend-mode');
  }

  $menuTrigger.on('click', () => {
    $body.toggleClass('menu-open');
  });

  if ($blockActivities && $blockActivities.length > 0) {
    const initialColor = $blockActivities.css('backgroundColor');
    const fullPageEffect = $blockActivities.data('effect') &&
      $blockActivities.data('effect') === 'full-page-effect';

    if (fullPageEffect) {
      $blockActivities.find('.single-activity').each((i, e) => {
        $(e).find('path').css('fill', $(e).data('color'));
        $(e).find('circle').css('stroke', $(e).data('color'));
        $(e).find('h3').css('color', $(e).data('color'));
      })
    }

    $blockActivities
      .on('mouseenter', '.single-activity', (e) => {
        if (fullPageEffect) {
          $body.addClass('color-inversion').css('backgroundColor', $(e.currentTarget).data('color'));
        }
        $blockActivities.css('backgroundColor', $(e.currentTarget).data('color'));
      })
      .on('mouseleave', '.single-activity', () => {
        if (fullPageEffect) {
          $body.removeClass('color-inversion').css('backgroundColor', 'transparent');
        }
        $blockActivities.css('backgroundColor', initialColor);
      });
  }

  if ($listFilters) {
    const target = $listFilters.data('target');
    let $target = null;

    if (target && target !== '') {
      $target = $(target);
    } else {
      $target = $('.list');
    }

    if ($target) {
      $listFilters.on('click', e => {
        const $this = $(e.currentTarget);
        let color = $this.data('color');
        let filter = null;
        let filterValue = null;

        if (color.indexOf('--') === 0) {
          color = 'var(' + color + ')';
        }

        if ($this.hasClass('active')) {
          $listFilters.removeClass('active');
          $listFilters.find('path').css('fill', 'var(--papion-gray)');
        } else {
          filter = $this.data('filter');
          filterValue = $this.data('filter-value');

          $listFilters.removeClass('active');
          $listFilters.find('path').css('fill', 'var(--papion-gray)');
          $this.addClass('active');
          $this.find('path').css('fill', color);
        }

        $target.children().removeClass('active').css('backgroundColor', 'transparent');

        if (filter && filterValue) {
          $target.children()
            .filter('.' + filter + '-' + filterValue)
            .addClass('active')
            .css('backgroundColor', color);
          $target.addClass('filter-active');
        } else {
          $target.removeClass('filter-active');
        }
      });
    }
  }

  if ($animatedInView && $animatedInView.length > 0) {
    console.log('animated in view')
    let options = {
      // root: document.querySelector('...'),
      // rootMargin: '0px',
      threshold: 1.0,
    }

    let observerCallback = e => {
      e.forEach(element => {
        if (element.isIntersecting) {
          $(element.target).addClass('in-view');
        } else {
          $(element.target).removeClass('in-view')
        }
      })
    }

    let observer = new IntersectionObserver(observerCallback, options);
    observer.observe(document.querySelector('.animated-in-view'))
  }

  if ($blocksAccordion && $blocksAccordion.length > 0) {
    $blocksAccordion.find('.block-title').on('click', e => {
      $(e.currentTarget).parents('.block-accordion').toggleClass('active');
    })
  }

  if ($gallery && $gallery.length > 0) {
    $gallery.find('.more').on('click', () => {
      console.log('more')
      $gallery.addClass('open');
    });

    $gallery.find('.less').on('click', () => {
      console.log('less')
      $gallery.removeClass('open');
    });
  }

  if($slideshow && $slideshow.length > 0) {
    // eslint-disable-next-line no-unused-vars
    var swiper = new Swiper('.swiper-container', {
      centeredSlides: true,
      lazy: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoplay: {
        delay: 4000,
      },
    });
  }
});
